import React, { useState, useEffect } from "react";
import WhatsNewHeader from "../../components/journeyComponents/WhatsNew/WhatsNewHeader";
import Footer from "../../components/journeyComponents/Footer";

import AuthService, { getMyDetails } from "../../services/AuthService";
import config from "../../services/config";
import { SuccessToast, ErrorToast } from "../../components/uikit/src/components/toast";
import Loader from "../../components/uikit/src/components/Loader";
import "./newspost.css";
import { useUser } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";

const NewsPost = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const [editPostId, setEditPostId] = useState(null);


  const {
    setUserEmail,
    setuserName,
    userName,
    userEmail,
    setApps,
    apps,
  } = useUser();

  // ✅ Validate session on load
  useEffect(() => {
    async function initUserSession() {
      try {
        if (!userEmail || !userName || !apps || Object.keys(apps).length === 0) {
          const response = await getMyDetails();
          setUserEmail(response.email);
          setuserName(response.name);
          setApps(response.apps);
        }
        fetchPosts(); // load posts only after session is validated
      } catch (err) {
        console.error("Session expired or invalid");
        navigate("/login");
      }
    }

    initUserSession();
  }, []);

  const fetchPosts = async () => {
    try {
      setIsLoading(true);
      const response = await config.get("/api/posts/all");
      setPosts(response.data);
    } catch (error) {
      ErrorToast(error?.message || "Error fetching posts.");
      if (error?.response?.status === 401) {
        handleLogout();
      }
    } finally {
      setIsLoading(false);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const postData = { title, content };

  //   try {
  //     setIsLoading(true);
  //     const response = await config.post("/api/posts", postData);
  //     if (response.status === 201) {
  //       SuccessToast("Post saved successfully!");
  //       setPosts([...posts, response.data]);
  //       setTitle("");
  //       setContent("");
  //     }
  //   } catch (error) {
  //     ErrorToast(error?.message || "Failed to save post.");
  //     if (error?.response?.status === 401) {
  //       handleLogout();
  //     }
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const postData = { title, content };

    try {
      setIsLoading(true);
      let response;

      if (isEditing && editPostId) {
        response = await config.put(`/api/posts/${editPostId}`, postData);
        if (response.status === 200) {
          SuccessToast("Post updated successfully!");
          setPosts(
            posts.map((post) =>
              post.id === editPostId ? { ...post, ...postData } : post
            )
          );
          setIsEditing(false);
          setEditPostId(null);
        }
      } else {
        response = await config.post("/api/posts", postData);
        if (response.status === 201) {
          SuccessToast("Post saved successfully!");
          setPosts([...posts, response.data]);
        }
      }

      setTitle("");
      setContent("");
    } catch (error) {
      ErrorToast(error?.message || "Failed to save post.");
      if (error?.response?.status === 401) {
        handleLogout();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (post) => {
    setTitle(post.title);
    setContent(post.content);
    setIsEditing(true);
    setEditPostId(post.id);
  };

  const handleNewPost = () => {
    setTitle("");
    setContent("");
    setIsEditing(false);
    setEditPostId(null);
  };

  const handleDelete = async (id) => {
    try {
      setIsLoading(true);
      const response = await config.delete(`/api/posts/${id}`);
      if (response.status === 200) {
        SuccessToast("Post deleted successfully!");
        setPosts(posts.filter((post) => post.id !== id));
      }
    } catch (error) {
      ErrorToast(error?.message || "Failed to delete post.");
      if (error?.response?.status === 401) {
        handleLogout();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = async () => {
    await AuthService.Logout(userEmail);
    navigate("/login");
  };

  return (
    <>
      {isLoading && <Loader />}
      <WhatsNewHeader />
      <div className="tabs-container news-post-top-hgt">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <form className="mb-5" onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="title" className="form-label">
                    News Title:
                  </label>
                  <input
                    type="text"
                    id="title"
                    className="form-control"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="text" className="form-label">
                    News Post:
                  </label>
                  <textarea
                    id="text"
                    className="form-control"
                    rows="8"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    required
                  ></textarea>
                </div>
                <div className="flex">
                  <button type="submit" className="btn btn-primary">
                    {isEditing ? "Update Post" : "Save Post"}
                  </button>
                  {isEditing && (
                    <button className="btn btn-primary mx-2" onClick={handleNewPost}>
                      + New Post
                    </button>
                  )}
                </div>
              </form>
            </div>
            <div className="col-md-9">
              <table className="table table-bordered table-striped news-table-hgt news-table">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Title</th>
                    <th>News</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {posts.map((post, index) => (
                    <tr key={post.id}>
                      <td>{index + 1}</td>
                      <td>{post.title}</td>
                      <td>{post.content}</td>
                      <td className="align-middle text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <svg onClick={() => handleEdit(post)}
                            style={{ cursor: 'pointer' }}
                            xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4f46e5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pencil-icon lucide-pencil"><path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" /><path d="m15 5 4 4" /></svg>
                          <svg
                            onClick={() => handleDelete(post.id)}
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-trash trsh-fill-clr"
                            viewBox="0 0 16 16"
                          >
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                          </svg>
                        </div>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NewsPost;
